import { ref } from 'vue';
import { EntityFolder, EntityFolderEdit } from '@/entities/entityFolder/model';

export const useEntityFolderRecord = () => ref<EntityFolder>({
  title: '',
  entityItems: [],
  users: [],
  parents: [],
  children: [],
  labels: [],
});

export const useEntityFolderEditRecord = () => ref<EntityFolderEdit>({
  title: '',
  entityItems: [],
  users: [],
  parents: [],
  children: [],
  labels: [],
});
